// extracted by mini-css-extract-plugin
module.exports = {"navTabsContainer":"TabsContainer_navTabsContainer__as1sZ","tabContent":"TabsContainer_tabContent__2h4wC"};